(function () {
  "use strict";

  const ABOUT_LEGER_PATH = "/pages/about-leger";
  const CONFIG = {
    SCROLL_OFFSET: 20,
    LOADING_DURATION: 800,
    SCROLL_DELAY: 200,
    INITIAL_DELAY: 100,
    RETRY_DELAY: 200,
    LOADING_TRANSITION: 300,
    LOAD_DELAY: 500,
  };

  if (!window.location.pathname.includes(ABOUT_LEGER_PATH)) {
    return;
  }

  // ユーティリティ関数
  function getHeaderHeight() {
    return (
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height"
        )
      ) || 0
    );
  }

  function calculateScrollPosition(element, offset = 0) {
    const rect = element.getBoundingClientRect();
    return window.pageYOffset + rect.top - getHeaderHeight() + offset;
  }

  function smoothScrollTo(position) {
    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
  }

  function setVhUnit() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  // ビューポート高さの設定
  setVhUnit();
  window.addEventListener("resize", setVhUnit);
  window.addEventListener("load", setVhUnit);

  // ローディングオーバーレイ管理
  class LoadingOverlay {
    constructor() {
      this.overlay = null;
      this.isActive = false;
      this.init();
    }

    init() {
      if (window.location.hash) {
        this.createOverlay();
        this.show();
      }
    }

    createOverlay() {
      if (this.overlay) return;

      this.overlay = document.createElement("div");
      this.overlay.className = "anchor-loading-overlay";
      this.overlay.innerHTML =
        '<img src="https://leger.jp/cdn/shop/files/footer-logo.png" alt="LÉGER ロゴ" class="anchor-loading-logo">';
      document.body.appendChild(this.overlay);
    }

    show() {
      if (this.isActive) return;
      this.createOverlay();
      this.isActive = true;
      this.overlay.classList.add("active");
    }

    hide() {
      if (!this.overlay) return;
      this.overlay.classList.remove("active");
      setTimeout(() => {
        this.isActive = false;
      }, CONFIG.LOADING_TRANSITION);
    }
  }

  // アンカースクロール機能
  class AnchorScroller {
    constructor(loadingOverlay) {
      this.loadingOverlay = loadingOverlay;
      this.scrolling = false;
      this.init();
    }

    init() {
      this.handleInitialHash();
      this.bindClickEvents();
    }

    scrollToElement(targetId, showLoading = true) {
      if (this.scrolling) return false;

      const target = document.getElementById(targetId);
      if (!target) return false;

      this.scrolling = true;

      if (showLoading) {
        this.loadingOverlay.show();
      }

      const executeScroll = () => {
        const position = calculateScrollPosition(target, CONFIG.SCROLL_OFFSET);
        smoothScrollTo(position);

        setTimeout(() => {
          if (showLoading) {
            this.loadingOverlay.hide();
          }
          this.scrolling = false;
        }, CONFIG.LOADING_DURATION);
      };

      if (showLoading) {
        setTimeout(executeScroll, CONFIG.SCROLL_DELAY);
      } else {
        executeScroll();
      }

      return true;
    }

    handleInitialHash() {
      if (!window.location.hash) return;

      const targetId = window.location.hash.substring(1);

      const tryScroll = () => {
        const target = document.getElementById(targetId);
        if (target) {
          if (this.loadingOverlay.isActive) {
            setTimeout(() => {
              const position = calculateScrollPosition(
                target,
                CONFIG.SCROLL_OFFSET
              );
              smoothScrollTo(position);
              setTimeout(
                () => this.loadingOverlay.hide(),
                CONFIG.LOADING_DURATION
              );
            }, CONFIG.LOAD_DELAY);
          } else {
            this.scrollToElement(targetId, false);
          }
        } else {
          setTimeout(tryScroll, CONFIG.RETRY_DELAY);
        }
      };

      setTimeout(tryScroll, CONFIG.INITIAL_DELAY);

      window.addEventListener("load", () => {
        const target = document.getElementById(targetId);
        if (target && this.loadingOverlay.isActive) {
          setTimeout(() => {
            const position = calculateScrollPosition(
              target,
              CONFIG.SCROLL_OFFSET
            );
            smoothScrollTo(position);
            setTimeout(
              () => this.loadingOverlay.hide(),
              CONFIG.LOADING_DURATION
            );
          }, CONFIG.LOAD_DELAY);
        }
      });
    }

    bindClickEvents() {
      document.addEventListener("click", (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        e.preventDefault();
        const targetId = link.getAttribute("href").substring(1);

        if (this.scrollToElement(targetId)) {
          history.pushState(null, null, `#${targetId}`);
        }
      });
    }
  }

  // DOM準備完了時に初期化
  FoxTheme.DOMready(() => {
    const loadingOverlay = new LoadingOverlay();
    new AnchorScroller(loadingOverlay);
  });
})();
